import React from 'react'

import style from '../styles/goods.module.scss'
import { BlockLoader } from 'components/Loaders'
const Skeleton = () => {
  return (
    <div className={style.skeleton}>
      {
        Array(5).fill(0).map((_, index) => (
          <BlockLoader key={index} height={30} className={style.skeleton__item}/>
        ))
      }
    </div>
  )
}

export default Skeleton